import {
  ALLOW_DISALLOW_COUNTRY_SUCCESS,
  ALLOW_DISALLOW_COUNTRY_FAILED,
  RESET_ALLOW_DISALLOW_COUNTRY,
  LOADING_RALLOW_DISALLOW_COUNTRY,
  NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAllowDisallowCountry = () => {
  return { type: RESET_ALLOW_DISALLOW_COUNTRY };
};

const allowDisallowCountry = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_RALLOW_DISALLOW_COUNTRY });
  await partnerServices
    .post("allowAndDisallowCountry", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(allowDisallowCountrysuccess(res.data));
          break;
        default:
          dispatch(allowDisallowCountryFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY, payload: err });
    });
};
function allowDisallowCountrysuccess(data) {
  return {
    type: ALLOW_DISALLOW_COUNTRY_SUCCESS,
    payload: data,
  };
}
function allowDisallowCountryFailed(data) {
  return {
    type: ALLOW_DISALLOW_COUNTRY_FAILED,
    payload: data,
  };
}

export { resetAllowDisallowCountry, allowDisallowCountry };
